import { render } from "./Switch.vue?vue&type=template&id=366c3036&ts=true"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=366c3036&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__